// React & Hooks
import { memo } from "react";
import { useSelector } from "react-redux";

// Utilities & Helpers
import { useTranslate } from "helpers";

// API & Types
import { getActiveUser } from "services/api/users";


// UI Components

// Feature-Specific Components

// Constants

// Component Types
import { SettingDetailProps } from "./types";
// import { SettingDetailFormValues } from "services/api/settings/tenants/types";
// import { initialSettingDetailForm } from "services/api/settings/tenants/consts";


const SettingDetailCard: React.FC<SettingDetailProps> = (props) => {
  const { t } = useTranslate();
  const { user } = useSelector(getActiveUser);


  // const [setting, setSetting] = useState<SettingDetailFormValues>(
  //   initialSettingDetailForm
  // );

  // useEffect(() => {
  //   fetchSetting();
  // }, [user]);

  // const fetchSetting = async () => {
  //   setIsLoading(true);

  //   let result;
  //   try {
  //     result = await getSettingAPI("");
  //   } catch {
  //     setIsLoading(false);
  //     return;
  //   }

  //   setSetting(result);
  //   setIsLoading(false);

  //   setErrors({});
  // };

  // const handleEditSuccess = useCallback(() => {
  //   fetchSetting();
  //   setShowAddNewModal(false);
  // }, []);



  return (
    <div className="rounded-sm">
      {/* <div className="divide-y divide-slate-200 ">
        <div className="flex flex-col xl:flex-row gap-6 xl:gap-32">
          <div className="flex flex-col">
            <div>
              <p className="text-base font-bold text-slate-600 py-3">
                {t("admin.calculation.setting.detail.title")}
              </p>
              <p className="text-sm">
                {" "}
                {t("admin.calculation.setting.detail.description")}
              </p>
            </div>
          </div>
          <div className="flex flex-1 px-3 my-3">
            <div className="rounded-sm bg-white border min-w-[400px]">
              <div className="divide-y divide-slate-200 ">
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-2 px-3 my-3 ">
                    <Button
                      size="small"
                      variant="primary"
                      children={t("admin.change")}
                      onClick={() => setShowAddNewModal(true)}
                      startIcon="/media/icons/plus.svg"
                    />
                  </div>
                </div>
                <div className="px-4 py-2 min-h-[56px]">
                  <div className="text-xs font-medium uppercase text-slate-600 ">
                    {t("admin.calculation.setting.detail.rtvfee")}
                  </div>
                  <div className="text-sm text-slate-500 truncate">
                    {setting.rtvFee ?? 0} €
                  </div>
                </div>
                <div className="px-4 py-2 min-h-[56px]">
                  <div className="text-xs font-medium uppercase text-slate-600 ">
                    {t("admin.calculation.setting.detail.fireextinguisher")}
                  </div>
                  <div className="text-sm text-slate-500 truncate">
                    {setting.fireExtinguisher ?? 0} €
                  </div>
                </div>
                <div className="px-4 py-2 min-h-[56px]">
                  <div className="text-xs font-medium uppercase text-slate-600 ">
                    {t("admin.calculation.setting.detail.mandatoryequipment")}
                  </div>
                  <div className="text-sm text-slate-500 truncate">
                    {setting.mandatoryEquipment ?? 0} €
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAddNewModal && user && user.id && (
        <Modal show={showAddNewModal} onHide={() => setShowAddNewModal(false)}>
          <ModalHeader
            title={CALCULATION_SETTING_EDIT_PAGE_TITLE.text}
            onHide={() => setShowAddNewModal(false)}
          />
          <ModalBody>
            <SettingEditCard userId={user?.id} onSuccess={handleEditSuccess} />
          </ModalBody>
        </Modal>
      )} */}
    </div>
  );
};
export default memo(SettingDetailCard);
